import { useMemo } from 'react';
import { useHistory } from 'react-router-dom';

import useQueryParams from 'common/hooks/useQueryParams';
import {
  getMemberTabPath,
  MembersTab,
  MembersTabs,
} from 'features/Team/routes';

export const useTabQueryParam = () => {
  const history = useHistory();
  const setSelectedTab = (tab: MembersTab | null) => {
    history.replace(getMemberTabPath(tab));
  };
  const params = useQueryParams();
  const selectedTab = useMemo(() => {
    const stringParam = params.get('tab') ?? null;
    const validatedStringParam = MembersTabs.includes(stringParam as MembersTab)
      ? stringParam
      : null;

    return validatedStringParam === 'all'
      ? null
      : (stringParam as Exclude<MembersTab, 'all'> | null);
  }, [params]);

  return [selectedTab, setSelectedTab] as const;
};
